import { render } from "./OnGoingCare.vue?vue&type=template&id=04c1176e&lang=pug"
import script from "./OnGoingCare.vue?vue&type=script&lang=js"
export * from "./OnGoingCare.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__